import { ExtractAtomicOperationFromDefinition } from "../../../atomic-operations/index.js";
import {
  CellReferencesParseError,
  CellReferencesV2,
} from "../../../code/index.js";
import { TextCellId } from "../../../idTypeBrands.js";
import { RichTextDocument } from "../../../richTextTypes.js";
import { makeUpdateCellContentsOperation } from "../makeUpdateCellContentsOperation.js";

export interface TextCellUpdatableFields {
  richText: RichTextDocument;
  cellReferencesV2: CellReferencesV2 | null;
  cellReferencesParseError: CellReferencesParseError | null;
}

const _UpdateTextCellSafeFields: {
  [key in keyof TextCellUpdatableFields]: "";
} = {
  richText: "",
  cellReferencesV2: "",
  cellReferencesParseError: "",
};
export const UpdateTextCellSafeFields = Object.keys(_UpdateTextCellSafeFields);

export const UPDATE_TEXT_CELL = makeUpdateCellContentsOperation<
  TextCellUpdatableFields,
  TextCellId
>()({
  type: "UPDATE_TEXT_CELL",
  entityName: "TextCell",
  fieldName: "textCellId",
});
export type UPDATE_TEXT_CELL = ExtractAtomicOperationFromDefinition<
  typeof UPDATE_TEXT_CELL
>;
